import { createSlice } from '@reduxjs/toolkit';
import { organizationsApi } from '~/api/organizations-api';
export interface Organization {
  id: string;
}

interface OrganizationsState {
  organizations: Organization[];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: OrganizationsState = {
  organizations: [],
  status: 'idle',
  error: null,
};

const organizationsSlice = createSlice({
  name: 'organizations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch list of organizations
      .addMatcher(organizationsApi.endpoints.getOrganizations.matchPending, (state) => {
        state.status = 'loading';
      })
      .addMatcher(organizationsApi.endpoints.getOrganizations.matchFulfilled, (state, action) => {
        state.status = 'succeeded';
        state.organizations = action.payload;
      })
      .addMatcher(organizationsApi.endpoints.getOrganizations.matchRejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? 'Failed to fetch organizations';
      })

      // Create a new organization
      .addMatcher(organizationsApi.endpoints.createOrganization.matchPending, (state) => {
        state.status = 'loading';
      })
      .addMatcher(organizationsApi.endpoints.createOrganization.matchFulfilled, (state, action) => {
        state.status = 'succeeded';
        state.organizations.push(action.payload);
      })
      .addMatcher(organizationsApi.endpoints.createOrganization.matchRejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? 'Failed to create organization';
      })

      // Update an existing organization
      .addMatcher(organizationsApi.endpoints.updateOrganization.matchPending, (state) => {
        state.status = 'loading';
      })
      .addMatcher(organizationsApi.endpoints.updateOrganization.matchFulfilled, (state, action) => {
        state.status = 'succeeded';
        const index = state.organizations.findIndex((o) => o.id === action.payload.id);
        if (index !== -1) {
          state.organizations[index] = action.payload;
        }
      })
      .addMatcher(organizationsApi.endpoints.updateOrganization.matchRejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? 'Failed to update organization';
      });
  },
});

export default organizationsSlice.reducer;
